import React from "react";
import { motion } from "framer-motion";
import { Compass, BadgeCheck, Briefcase, Scale, Users, Server } from "lucide-react";
import { TRUST_POINTS } from "../data/content";

const iconMap = {
  compass: Compass,
  "badge-check": BadgeCheck,
  briefcase: Briefcase,
  scale: Scale,
  users: Users,
  server: Server,
};

export default function TrustSection() {
  return (
    <section id="trust" className="py-20 sm:py-28 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary">The Techmate Difference</p>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">
            Consulting depth. Delivery discipline. Compliance clarity.
          </h2>
          <p className="mt-4 text-muted-foreground text-base leading-relaxed">
            We combine board-level cybersecurity advisory with hands-on architecture and
            managed operations — vendor-neutral by design, compliance-led by conviction, and always
            measured by the business outcomes your leadership actually reports on.
          </p>
        </div>
        <div className="mt-12 grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {TRUST_POINTS.map((t, idx) => {
            const Icon = iconMap[t.icon] || BadgeCheck;
            return (
              <motion.div
                key={t.title}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.5, delay: idx * 0.05 }}
                data-testid={`trust-point-${idx}`}
                className="card-lift rounded-2xl border border-border bg-card p-6 sm:p-7"
              >
                <div className="h-12 w-12 rounded-xl bg-primary/10 text-primary grid place-items-center">
                  <Icon className="h-5 w-5" strokeWidth={1.75} />
                </div>
                <div className="mt-5 font-display text-lg sm:text-xl font-semibold">{t.title}</div>
                <div className="mt-1 h-1 w-8 bg-secondary rounded-full" />
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
